export enum CRON_JOBS_IDS {
  X_POST_TWEET = 'bd74911f-9dbf-478a-8643-b1196ca69f0d',
  X_POST_TWEET_2 = '7659121e-2e0b-4131-ab78-77d55b9e0735',
  X_POST_TWEET_3 = 'f2a73d41-5bcf-4755-a484-5892ac22f1b9',
  X_POST_TWEET_4 = 'bec40f5b-5d90-4550-a8c9-fa35ee47e328',
  X_REPLY_TO_HASH_TAG_TWEET = 'abc60d59-8e98-4f45-8cb1-c8cbd7f3d404',
  X_REPLY_TO_MENTIONS_TWEET = 'f0edf050-1437-4090-87c6-c2c5040d9e50',
  X_REPLY_TO_FOLLOWED_USERS_TWEET = '3a76a7fa-d73c-4ced-972e-5d21cee7e848',
  UPDATE_ACCOUNT_NFTS = 'f5641370-5408-455f-b236-5e7b3580ff39',
  UPDATE_PRODUCT_NFTS = '6a8f7db6-9714-4eaf-b063-c71c9adbc8a0',
  EXPIRED_TOKENS_CLEANUP = '6714fdb3-ed54-4b56-8b23-542f03382420',
  TRANSACTION_QUEUE_CLEANUP = '06a05495-b2ab-45f0-bea2-1dab44359991',
  SIDE_LANGUAGES_TRANSLATIONS = '180f98a0-c328-4024-8d0e-e1e9b9b31226',
  X_TRENDS = 'bbab01dd-bd0a-41d9-bc69-d0356800c7f8',
  ESG_TODAY_TRENDS = 'f9736174-ac2f-4322-bc85-9dce0f21b5bd',
  COINTELEGRAPH_TRENDS = 'c61e7d5a-36fc-495d-a42d-a402609e2489',
  TG_BOT_APPROVED_SCANS_DAILY = 'e8c2beac-5605-4f55-bec1-3a4eccaccb42',
  S2E_CONSUMER_SCANS_APPROVAl = '8a66e117-47d5-4fe4-a576-e5f11ccebbb3',
  S2E_SEND_MISSING_DECRYPTED_TX = '31fc5411-d34a-4645-96bc-cc73b157a926',
  S2E_SEND_MISSING_ENCRYPTED_TX = '76c19c3d-5395-485f-af2c-f8eb1c8ecf89',
  VECTOR_STORE_UPDATE = '0fcf7589-0718-4544-a909-0dbfaedaaf5a',
}

export enum CRON_EXPRESSION {
  'Every Second' = '* * * * * *',
  'Every 5 Seconds' = '*/5 * * * * *',
  'Every 10 Seconds' = '*/10 * * * * *',
  'Every 30 Seconds' = '*/30 * * * * *',
  'Every Minute' = '*/1 * * * *',
  'Every 5 Minutes' = '0 */5 * * * *',
  'Every 10 Minutes' = '0 */10 * * * *',
  'Every 15 Minutes' = '0 */15 * * * *',
  'Every 20 Minutes' = '0 */20 * * * *',
  'Every 30 Minutes' = '0 */30 * * * *',
  'Every Hour' = '0 0-23/1 * * *',
  'Every 2 Hours' = '0 0-23/2 * * *',
  'Every 3 Hours' = '0 0-23/3 * * *',
  'Every 4 Hours' = '0 0-23/4 * * *',
  'Every 5 Hours' = '0 0-23/5 * * *',
  'Every 6 Hours' = '0 0-23/6 * * *',
  'Every 7 Hours' = '0 0-23/7 * * *',
  'Every 8 Hours' = '0 0-23/8 * * *',
  'Every 9 Hours' = '0 0-23/9 * * *',
  'Every 10 Hours' = '0 0-23/10 * * *',
  'Every 11 Hours' = '0 0-23/11 * * *',
  'Every 12 Hours' = '0 0-23/12 * * *',
  'Every Day at 1AM' = '0 01 * * *',
  'Every Day at 2AM' = '0 02 * * *',
  'Every Day at 3AM' = '0 03 * * *',
  'Every Day at 4AM' = '0 04 * * *',
  'Every Day at 5AM' = '0 05 * * *',
  'Every Day at 6AM' = '0 06 * * *',
  'Every Day at 7AM' = '0 07 * * *',
  'Every Day at 8AM' = '0 08 * * *',
  'Every Day at 9AM' = '0 09 * * *',
  'Every Day at 10AM' = '0 10 * * *',
  'Every Day at 11AM' = '0 11 * * *',
  'Every Day at Noon' = '0 12 * * *',
  'Every Day at 1PM' = '0 13 * * *',
  'Every Day at 2PM' = '0 14 * * *',
  'Every Day at 3PM' = '0 15 * * *',
  'Every Day at 4PM' = '0 16 * * *',
  'Every Day at 5PM' = '0 17 * * *',
  'Every Day at 6PM' = '0 18 * * *',
  'Every Day at 7PM' = '0 19 * * *',
  'Every Day at 8PM' = '0 20 * * *',
  'Every Day at 9PM' = '0 21 * * *',
  'Every Day at 10PM' = '0 22 * * *',
  'Every Day at 11PM' = '0 23 * * *',
  'Every Day at Midnight' = '0 0 * * *',
  'Every Week' = '0 0 * * 0',
  'Every Weekday' = '0 0 * * 1-5',
  'Every Weekend' = '0 0 * * 6,0',
  'Every 1st Day of Month at Midnight' = '0 0 1 * *',
  'Every 1st Day of Month at Noon' = '0 12 1 * *',
  'Every 2nd Hour' = '0 */2 * * *',
  'Every 2nd Hour from 1AM through 11PM' = '0 1-23/2 * * *',
  'Every 2nd Month' = '0 0 1 */2 *',
  'Every Quarter' = '0 0 1 */3 *',
  'Every 6 Months' = '0 0 1 */6 *',
  'Every Year' = '0 0 1 1 *',
  'Every 30 Minutes between 9AM and 5PM' = '0 */30 9-17 * * *',
  'Every 30 Minutes between 9AM and 6PM' = '0 */30 9-18 * * *',
  'Every 30 Minutes between 10AM and 7PM' = '0 */30 10-19 * * *',
  'Monday to Friday at 1AM' = '0 0 01 * * 1-5',
  'Monday to Friday at 2AM' = '0 0 02 * * 1-5',
  'Monday to Friday at 3AM' = '0 0 03 * * 1-5',
  'Monday to Friday at 4AM' = '0 0 04 * * 1-5',
  'Monday to Friday at 5AM' = '0 0 05 * * 1-5',
  'Monday to Friday at 6AM' = '0 0 06 * * 1-5',
  'Monday to Friday at 7AM' = '0 0 07 * * 1-5',
  'Monday to Friday at 8AM' = '0 0 08 * * 1-5',
  'Monday to Friday at 9AM' = '0 0 09 * * 1-5',
  'Monday to Friday at 9:30AM' = '0 30 09 * * 1-5',
  'Monday to Friday at 10AM' = '0 0 10 * * 1-5',
  'Monday to Friday at 11AM' = '0 0 11 * * 1-5',
  'Monday to Friday at 11:30AM' = '0 30 11 * * 1-5',
  'Monday to Friday at Noon' = '0 0 12 * * 1-5',
  'Monday to Friday at 1PM' = '0 0 13 * * 1-5',
  'Monday to Friday at 2PM' = '0 0 14 * * 1-5',
  'Monday to Friday at 3PM' = '0 0 15 * * 1-5',
  'Monday to Friday at 4PM' = '0 0 16 * * 1-5',
  'Monday to Friday at 5PM' = '0 0 17 * * 1-5',
  'Monday to Friday at 6PM' = '0 0 18 * * 1-5',
  'Monday to Friday at 7PM' = '0 0 19 * * 1-5',
  'Monday to Friday at 8PM' = '0 0 20 * * 1-5',
  'Monday to Friday at 9PM' = '0 0 21 * * 1-5',
  'Monday to Friday at 10PM' = '0 0 22 * * 1-5',
  'Monday to Friday at 11PM' = '0 0 23 * * 1-5',
}
